import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { TimelineEventCategory } from '../types/timeline.types';
import { DealroomEventType } from '../../timeline/types/log.types';

export default class TimelineConstants {
  static eventTypesByCategory = (category: TimelineEventCategory) =>
    ({
      [TimelineEventCategory.General]: [
        DealroomEventType.Published,
        DealroomEventType.Unpublished,
        DealroomEventType.Deleted,
        DealroomEventType.Visited,
        DealroomEventType.FeatureSettingsUpdated,
        DealroomEventType.AccessRuleUpdated,
        DealroomEventType.ParticipantCreated,
        DealroomEventType.ParticipantDeleted,
        DealroomEventType.RoomOwnerUpdated,
      ],
      [TimelineEventCategory.Chat]: [DealroomEventType.ConversationMessageCreated],
      [TimelineEventCategory.Updates]: [DealroomEventType.PostCreated],
      [TimelineEventCategory.Comments]: [
        DealroomEventType.ContextualCommentReplyCreated,
        DealroomEventType.ContextualCommentUpdated,
      ],
      [TimelineEventCategory.Map]: [
        DealroomEventType.ActionPlanUpdated,
        DealroomEventType.TaskUpdated,
      ],
      [TimelineEventCategory.Files]: [
        DealroomEventType.FileUploaded,
        DealroomEventType.FileDownloaded,
        DealroomEventType.FileDeleted,
      ],
    })[category] || [];

  static eventCategoriesOptions = () => [
    {
      category: TimelineEventCategory.General,
      label: t('dr_timeline_event_category_general'),
      icon: 'publish',
      events: this.eventTypesByCategory(TimelineEventCategory.General),
    },
    {
      category: TimelineEventCategory.Chat,
      label: t('dr_timeline_event_category_chat'),
      icon: 'conversation',
      events: this.eventTypesByCategory(TimelineEventCategory.Chat),
    },
    {
      category: TimelineEventCategory.Updates,
      label: t('dr_timeline_event_category_updates'),
      icon: 'megaphone',
      events: this.eventTypesByCategory(TimelineEventCategory.Updates),
    },
    {
      category: TimelineEventCategory.Comments,
      label: t('dr_timeline_event_category_comments'),
      icon: 'comments',
      events: this.eventTypesByCategory(TimelineEventCategory.Comments),
    },
    {
      category: TimelineEventCategory.Map,
      label: t('dr_timeline_event_category_map'),
      icon: 'clipboard',
      events: this.eventTypesByCategory(TimelineEventCategory.Map),
    },
    {
      category: TimelineEventCategory.Files,
      label: t('dr_timeline_event_category_files'),
      icon: 'file-blank',
      events: this.eventTypesByCategory(TimelineEventCategory.Files),
    },
  ];
}
